define('app/factories/address_form_factory',['app/setup', 'app/models/address', 'app/views/address_form_view'],
  function(takhfifan, Address, address_form_view) {
    return new takhfifan.AddressFormView({ model: new takhfifan.Address() });
});

